import { FounderQuote } from "@/components/FounderQuote";

export const ReplyDeliverabilityFounderQuote = () => {
  return (
    <FounderQuote
      quote="We've shifted every client's KPI from open rate to reply rate. Open tracking is compromised—between Apple Mail Privacy Protection hiding real opens and security bots generating fake ones, the metric is meaningless. Replies can't be faked. When someone takes time to respond, that's genuine engagement ISPs reward."
      author="aman"
      tagline="Helping businesses transition to reply-first email strategies"
    />
  );
};